import { Link } from 'react-router-dom';
function Foot() {
  return (
    <div>

      <div className="container-fluid bg-dark" >
        <section className="service">
          <div className="row container-fluid he text-white justify-content-center g-0 p-0">
            <div className="col-12 col-md-4">
              <h4 className="py-3 case">Service We Provide</h4>
              <Link className="mx-md-2" to="/Aluminium-Glass-Office-Partition-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Aluminium Glass Office Partition Services in Pune</Link>
<Link className="mx-md-2" to="/Toughened-Glass-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Toughened Glass Work Services in Pune</Link>
<Link className="mx-md-2" to="/Door-Partition-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Door Partition Services in Pune</Link>
<Link className="mx-md-2" to="/ACP-Cladding-Panel-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> ACP Cladding Panel Installation Services in Pune</Link>
<Link className="mx-md-2" to="/Aluminium-Glass-Window-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Aluminium Glass Window Installation Services in Pune</Link>
<Link className="mx-md-2" to="/Soundproof-Glass-Window-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Soundproof Glass Window Installation Services in Pune</Link>
<Link className="mx-md-2" to="/Aluminium-Mosquito-Net-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Aluminium Mosquito Net Installation Services in Pune</Link>
<Link className="mx-md-2" to="/Bird-Net-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Bird Net Installation Services in Pune</Link>
<Link className="mx-md-2" to="/Invisible-Grill-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Invisible Grill Installation Services in Pune</Link>
<Link className="mx-md-2" to="/MS-Fabrication-Door-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> MS Fabrication Door Installation Services in Pune</Link>
<Link className="mx-md-2" to="/MS-Fabrication-Shade-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> MS Fabrication Shade Installation Services in Pune</Link>
<Link className="mx-md-2" to="/MS-Fabrication-Grill-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> MS Fabrication Grill Installation Services in Pune</Link>


            </div>

            <div className="col-12 col-md-4 text-white">
              <h4 className="py-3 case">Service We Provide</h4>
              <Link className="mx-md-2" to="/MS-Fabrication-Slide-Door-Installation-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> MS Fabrication Slide Door Installation Services in Pune</Link>
<Link className="mx-md-2" to="/MS-Fabrication-Industrial-Shade-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> MS Fabrication Industrial Shade Services in Pune</Link>
<Link className="mx-md-2" to="/Industrial-Fabrication-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Industrial Fabrication Services in Pune</Link>
<Link className="mx-md-2" to="/Furniture-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Furniture Work Services in Pune</Link>
<Link className="mx-md-2" to="/Industrial-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Industrial Work Services in Pune</Link>
<Link className="mx-md-2" to="/Home-Renovation-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Home Renovation Work Services in Pune</Link>
<Link className="mx-md-2" to="/Painting-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> All Types of Painting Work Services in Pune</Link>
<Link className="mx-md-2" to="/Foil-Ceiling-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Foil Ceiling Work Services in Pune</Link>
<Link className="mx-md-2" to="/Electrical-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Electrical Work Services in Pune</Link>
<Link className="mx-md-2" to="/Puff-Panel-Room-Installation-in-Pune"><i className="fas fa-cogs darkcolor"></i> Puff Panel Room Installation in Pune</Link>
<Link className="mx-md-2" to="/Maintenance-Repair-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> Maintenance & Repair Services in Pune</Link>
<Link className="mx-md-2" to="/PCC-Epoxy-Flooring-Work-Services-in-Pune"><i className="fas fa-cogs darkcolor"></i> PCC Work & Epoxy Flooring Services in Pune</Link>

            </div>


            <div className="col-12 col-md-3">
              <h4 className="py-3 case">Service We Provide</h4>
              <h4 className="case darkcolor">Anjali Enterprises  </h4>
              <p>
                <i className="fas fa-phone-alt darkcolor"></i>
                <a href="tel:+918793220265" className='d-inline'> +91 8793220265</a><br />
              </p>

              <p >
                <i className="fas fa-envelope darkcolor"></i>
                <a href="mailto:info@anjalienterprisesindia.com" className='d-inline'>  info@anjalienterprisesindia.com
                </a>
              </p>

              <p className='text-white'><strong className='darkcolor'>Address:</strong><br />
                Anjali Enterprises :<br />
                Bhairab nivas lane number 8
                uttareshwar Nagar S/R nb.275
                sathe vasti Lohegaon, Pune
                <br /> Maharashtra - 411047
              </p>
              <div className="mt-4">
                <h5 className="case darkcolor">Our Location:</h5>



                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1538.4935886174787!2d73.93324340671968!3d18.560772465498047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1b0b5e249ef%3A0x30d3355d77b6b44d!2sAnjali%20enterprises!5e1!3m2!1sen!2sin!4v1742963107704!5m2!1sen!2sin" width="100%" height="200" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


              </div>
            </div>
            <hr />
            <p className="text-white text-center">
              All Rights Reserved @ <span className="Coloo">Anjali Enterprises</span>  <span id="date">{new Date().getFullYear()}</span>{' '} Developed By
              <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="Coloo">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By
              <a href="https://www.urvahosting.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="Coloo">&nbsp;Urva Hosting</span>
              </a>
            </p>




          </div>
        </section>
      </div>
    </div>
  );
}

export default Foot;